/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateB2CUserCommand } from '../../models/create-b-2-c-user-command';
import { CreatedApiResponse } from '../../models/created-api-response';

export interface CreateB2CUserAsync$Plain$Params {
      body?: CreateB2CUserCommand
}

export function createB2CUserAsync$Plain(http: HttpClient, rootUrl: string, params?: CreateB2CUserAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatedApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createB2CUserAsync$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatedApiResponse>;
    })
  );
}

createB2CUserAsync$Plain.PATH = '/api/user/b2c';
